import React, { useEffect, useState } from "react";
import { getUser, UpdateUser } from "../../services/auth/User";
import Loader2 from "../../components/Loader2";
import toast from "react-hot-toast";
import './profile.css'

function Profile() {
  const [isPending, setIsPending] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    userWalletAddress: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    try {
      const storedUser = localStorage.getItem("userData");
      if (!storedUser) {
        throw new Error("No user found in local storage");
      }
      const parsedUser = JSON.parse(storedUser);
      setIsPending(true);
      const response = await getUser(parsedUser.authToken);
      // console.log(response)
      setFormData({
        name: response.name || "",
        email: response.email || "",
        mobile: response.phone || "",
        address: response.address || "",
        userWalletAddress: response.userWalletAddress || "",
        });
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      toast.error("Failed to fetch user details!");
    } finally {
      setIsPending(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleUpdate = async () => {
    setIsPending(true);
    // Validate mobile number length
    // Validate name length
    if (formData.name.length < 3 || formData.name.length > 30) {
      toast.error("Name must be between 3 and 30 Letters!");
      setIsPending(false);
      return;
    }

    // Validate mobile number length
    if (formData.mobile.length !== 10) {
      toast.error("Mobile number must be exactly 10 digits!");
      setIsPending(false);
      return;
    }

    // Validate address length
    if (formData.address.length > 200) {
      toast.error("Address must be 200 Letters or less!");
      setIsPending(false);
      return;
    }
    try {
      await UpdateUser(formData);
      toast.success("Profile Details updated successfully!");
      setIsEditing(false);

    } catch (error) {
      console.error("Failed to update user:", error);
      toast.success("Failed to update user!");
    } finally {
      setIsPending(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    fetchUserDetails();
   
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return <>
  {isPending && <Loader2 /> }
    <div className="contain">
        <h1>Profile</h1>

    <div className="boxy">
    <div className="tab-top">
      <h3>Profile Details</h3>
    </div>
    <div className="seperator"></div>
    <div className="tab-body">
      <form className="form-1">
        <div className="form-line">
          <div className="form-input input-f">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              value={formData.name}
              disabled={!isEditing}
              onChange={handleChange}
              name="name"
              required
            />
          </div>
        </div>
        <div className="form-line">
          <div className="form-input input-h">
            <label>Email</label>
            <input
              type="text"
              placeholder="Enter your Email Address"
              value={formData.email}
              disabled
              onChange={handleChange}
              name="email"
              required
            />
          </div>
          <div className="form-input input-h">
            <label>Phone Number</label>
            <input
              type="text"
              placeholder="Enter your Mobile Number"
              value={formData.mobile}
              disabled={!isEditing}
              onChange={handleChange}
              name="mobile"
              required
            />
          </div>
        </div>
          <div className="form-input input-h">
            <label>User Wallet Address</label>
            <input
              type="text"
              placeholder="Enter your Wallet Address"
              value={formData.userWalletAddress}
              disabled={!isEditing}
              onChange={handleChange}
              name="userWalletAddress"
              required
            />
          </div>
        <div className="form-line">
          <div className="form-input input-f">
            <label>Address</label>
            <textarea
              placeholder="Enter Your Full Address"
              value={formData.address}
              disabled={!isEditing}
              onChange={handleChange}
              name="address"
              required
            ></textarea>
          </div>
        </div>
        <div className="form-1 btn-group">
          {!isEditing ? (
            <button
              type="button"
              className="form-btn-1 btn-f"
              onClick={handleEdit}
            >
              Edit Details
            </button>
          ) : (
            <>
              <button
                type="button"
                className="form-btn-1 btn-f"
                onClick={handleUpdate}
              >
                Update
              </button>
              <button
                type="button"
                className="form-btn-1 btn-h"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  </div>
  </div>

  </>;
}

export default Profile;
